import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// دالة لجلب سجل تسجيل الدخول للتينانتس
export const getTenantsLoginHistory = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`get/tenants/login/history?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};
